import React from 'react';

const StopPropagationClick = ({ tag: Tag = 'div', children, ...rest }) => {
  const handleOnClick = event => event.stopPropagation();

  return (
    <Tag {...rest} onClick={handleOnClick}>
      {children}
    </Tag>
  );
};

export default StopPropagationClick;
